export const ASC = 'ascending';
export const DESC = 'descending';